import * as React from 'react';
import { CheckboxWithLabel } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';

const SaveDetailsToAccount = ({ checked , onChange  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        id: "overwritePersonalDetails",
        value: "overwritePersonalDetails",
        checked: checked,
        onChange: onChange,
        label: getLabel('checkout.login.express.checkbox')
    });
};

export { SaveDetailsToAccount };
//# sourceMappingURL=SaveDetailsToAccount.js.map
